(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["labreeze-brala-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[id^="LabreezeBrala-"]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const reveal = root.querySelectorAll('[data-lbb-reveal]');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('is-in');
        });
      }, { threshold: .12 });
      reveal.forEach((item) => observer.observe(item));

      root.querySelectorAll('[data-lbb-slider]').forEach((slider) => {
        const slides = Array.from(slider.querySelectorAll('.lbb-hero-slide'));
        const dots = Array.from(slider.querySelectorAll('[data-lbb-dot]'));
        if (slides.length < 2) return;
        let active = 0;
        let timer;
        const show = (next) => {
          active = (next + slides.length) % slides.length;
          slides.forEach((slide, index) => {
            const selected = index === active;
            slide.classList.toggle('is-active', selected);
            slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
            slide.tabIndex = selected ? 0 : -1;
          });
          dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
        };
        const play = () => {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          clearInterval(timer);
          timer = setInterval(() => show(active + 1), 4300);
        };
        dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); play(); }));
        slider.addEventListener('mouseenter', () => clearInterval(timer));
        slider.addEventListener('mouseleave', play);
        slider.addEventListener('focusin', () => clearInterval(timer));
        slider.addEventListener('focusout', play);
        play();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["labreeze-scroll-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[id^="LabreezeScrollStory-"]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      document.documentElement.classList.add('lbs-scroll-page');
      const scenes = [...root.querySelectorAll('[data-lbs-scene]')];
      const progress = [...root.querySelectorAll('.lbs-progress a')];
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          const index = scenes.indexOf(entry.target);
          progress.forEach((link, itemIndex) => link.classList.toggle('is-active', itemIndex === index));
        });
      }, { threshold: .28 });
      scenes.forEach((scene) => observer.observe(scene));
      const rail = root.querySelector('[data-lbs-rail]');
      const move = (direction) => rail?.scrollBy({ left: direction * Math.min(650, rail.clientWidth * .85), behavior: 'smooth' });
      root.querySelector('[data-lbs-prev]')?.addEventListener('click', () => move(-1));
      root.querySelector('[data-lbs-next]')?.addEventListener('click', () => move(1));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
